import header from '~/store/header'
import locale from '~/store/locale'

const modules = {
  header,
  locale,
}

export default {
  namespaced: true,
  modules,
}
